import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addPartyRoleSetting = (party_roles) => {
  return axios.post(API + "company/company-settings/", {
    party_roles,

  
  },{headers: authHeader(),});
};
const AddPartyRoleSettingService = {
    addPartyRoleSetting,
    
  };
  export default AddPartyRoleSettingService;